
import { withCompController } from '@wix/editor-elements-integrations';
import type {
  IWbuColumnControllerControlProps,
  IWbuColumnControllerControlMapperProps,
  IWbuColumnControllerControlControllerProps,
  IWbuColumnControllerControlStateValues,
} from '../../../components/WbuColumnControllerControl/WbuColumnControllerControl.props';

export default withCompController<
  IWbuColumnControllerControlMapperProps,
  IWbuColumnControllerControlControllerProps,
  IWbuColumnControllerControlProps,
  IWbuColumnControllerControlStateValues
>(({ mapperProps, controllerUtils, stateValues }) => {
  const { editorType } = stateValues
  return {
    ...mapperProps,
    editorType,
    updateComponentPropsInViewer: props => {
      controllerUtils.updateProps(props);
    }
  }
});
